import { session } from "services/storage/general";

export const configSessionStorage = {
    spaceAdmin: {
        spaceTypeId: {
            get: () => Number(session.get("configSpaceAdminSpaceTypeId")) || 0,
            set: value => session.set("configSpaceAdminSpaceTypeId", value),
            remove: () => session.remove("configSpaceAdminSpaceTypeId")
        },
        campus: {
            get: () => {
                const campus = JSON.parse(session.get("configSpaceAdminCampus"));
                return campus && {
                    id: campus.id,
                    name: campus.name
                };
            },
            set: ({ id, name }) => session.set("configSpaceAdminCampus", JSON.stringify({ id, name })),
            remove: () => session.remove("configSpaceAdminCampus")
        },
        spaceId: {
            get: () => Number(session.get("configSpaceAdminSpaceId")) || 0,
            set: value => session.set("configSpaceAdminSpaceId", value),
            remove: () => session.remove("configSpaceAdminSpaceId")
        }
    }
};